const initialState = {
  inspektorHistoryData: [],
  onOffData: null
}

const inspektorHistory = (state = initialState, action) => {
  switch (action.type) {
    case "ISNPEKTOR_HISTORY":
      return { ...state, inspektorHistoryData: action.val }
    case "SET_ON_OFF_DATA":
      return { ...state, onOffData: action.val }
    default:
      return state
  }
}

export default inspektorHistory
